module.exports = __webpack_public_path__ + "img/booth-played.0c88dc45.svg";